import React from "react";
import { Input, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import Router from "next-translate/Router";
import useTranslation from "next-translate/useTranslation";
import { Storage } from "src/services/Storage";
import { APP_PASSWORD_FORGOTTEN_ROUTE } from "src/modules/smile/shared/consts";
import { FormLabel } from "src/shared/components/FormLabel";

const SmileSignupPasswordInput = () => {
  const { t } = useTranslation();
  const { register, errors, getValues } = useFormContext();

  return (
    <FormControl id="password" isInvalid={!!errors.password} isRequired>
      <FormLabel>{t("smile:pixSignup_passwordLabel")}</FormLabel>
      <Input
        ref={register({
          required: t("smile:form_formRequiredField"),
          minLength: {
            value: 7,
            message: t("smile:form_formPasswordLength"),
          },
        })}
        name="password"
        type={"password"}
        placeholder="******"
        height={"50px"}
        bg={"rgba(255, 255, 255, 0.8)"}
        border={"1px solid"}
        borderColor={"#BBD1F2"}
        borderRadius={"2px"}
        boxShadow={"0px 20px 32px rgba(70, 25, 164, 0.05)"}
        fontFamily="Montserrat"
        fontSize={"14px"}
        fontWeight={"500"}
        lineHeight={"110%"}
      />
      <FormErrorMessage>
        {(() => {
          if (errors.password?.message === "Incorrect password") {
            return (
              <span>
                {"You already have an account, click "}
                <a
                  href="/"
                  style={{ textDecoration: "underline" }}
                  onClick={(e) => {
                    e.preventDefault();
                    const email = getValues("email");
                    Storage.smileForgotPasswordDefaultEmail.set(email);
                    Router.pushI18n(APP_PASSWORD_FORGOTTEN_ROUTE);
                  }}
                >
                  here
                </a>
                {" to reset password"}
              </span>
            );
          }

          return errors.password?.message;
        })()}
      </FormErrorMessage>
    </FormControl>
  );
};

export default SmileSignupPasswordInput;
